import { useAuth } from "../AuthProvider";
import { useTranslation } from 'react-i18next';
import { ADMIN, GAME_MASTER } from '../Roles';
import HoverHelp from './HoverHelp';

const Team = ({ team, showName }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const membersLabel = showName ? '' : t('teams.team') + ":";

    return (
        <>
        { (auth.roles.includes(ADMIN) || auth.roles.includes(GAME_MASTER)) && !team.automaton &&
            <div style={{ padding: '6px' }}>
                {t('teams.password')}: <b>{team.password}</b>
                <HoverHelp id="team-password" text={t('passwords.help.team-password')} />
            </div>
        }
        <div style={{ padding: '6px' }}>
            {showName &&
                <span key="team-name"><b>{team.name}</b>: </span>
            }
            {team.automaton ? t('teams.automaton') : membersLabel}
            {!team.automaton && team.members.map(member => {
                const role = member.role ? `(${member.role})` : '';
                return <span key={member.name}> {member.name} {role};</span>
                })
            }
        </div>
        </>
    );
};

export default Team;
